import { MODAL_AUTH_RESET_PASSWORD } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { AuthenticatedMain } from './AuthenticatedMain'

export const ResetPassword = () => {
  const dispatch = useDispatch()

  const { uuid: resetId } = useParams<{
    uuid: string
  }>()

  dispatch(
    // @ts-expect-error
    openModal(MODAL_AUTH_RESET_PASSWORD, {
      isLocked: true,
      resetId,
    })
  )

  return <AuthenticatedMain />
}
